export default {
    loaded: ({lucky_wheel}) => lucky_wheel.loaded,
    opened: ({lucky_wheel}) => lucky_wheel.opened,
    wheel: ({lucky_wheel}) => lucky_wheel.wheel,
    sectors: ({lucky_wheel}) => lucky_wheel.sectors,
    rewards: ({lucky_wheel}) => lucky_wheel.rewards,
    timeout: ({lucky_wheel}) => lucky_wheel.timeout,
    prize: ({lucky_wheel}) => lucky_wheel.prize,
    prize_button: ({lucky_wheel}) => lucky_wheel.prize_button
}